import { useMemo } from "react";

function useFilterPanelContext({
    filtersDisabled, debounceMultiSelectUpdates, applyFilter, termsInclude,
    setTermsInclude, termsExclude, setTermsExclude, industryChoices,
    industryInclude, setIndustryInclude, industryExclude, setIndustryExclude,
    locations, setLocations, locationChoices, revenueLowerBound,
    revenueUpperBound, setRevenueLowerBound, setRevenueUpperBound, employeesLowerBound,
    employeesUpperBound, setEmployeesLowerBound, setEmployeesUpperBound, naturalQuery,
    setNaturalQuery, orderedSavedSearchChoices, selectedSavedSearch, handleSelectSavedSearch,
    initiateDelete, handlePinSavedSearch, initiateEditSearch, pinnedIds,
    rowActions, savedSearchCatalog, isEditingSavedSearch
}) {
const panelContext = useMemo(
    () => ({
      filtersDisabled,
      debounceMultiSelectUpdates,
      onApply: applyFilter,
      termsInclude,
      setTermsInclude,
      termsExclude,
      setTermsExclude,
      industryChoices,
      industryInclude,
      setIndustryInclude,
      industryExclude,
      setIndustryExclude,
      locations,
      setLocations,
      locationChoices,
      revenueLowerBound,
      revenueUpperBound,
      setRevenueLowerBound,
      setRevenueUpperBound,
      employeesLowerBound,
      employeesUpperBound,
      setEmployeesLowerBound,
      setEmployeesUpperBound,
      naturalQuery,
      setNaturalQuery,
      savedSearchChoices: orderedSavedSearchChoices,
      selectedSavedSearch,
      onSelectSavedSearch: handleSelectSavedSearch,
      onDeleteSavedSearch: initiateDelete,
      onPinSavedSearch: handlePinSavedSearch,
      onRenameSavedSearch: initiateEditSearch,
      pinnedIds,
      rowActions,
      savedSearchCatalog,
      isEditingSavedSearch,
    }),
    [
      filtersDisabled,
      debounceMultiSelectUpdates,
      applyFilter,
      termsInclude,
      setTermsInclude,
      termsExclude,
      setTermsExclude,
      industryChoices,
      industryInclude,
      setIndustryInclude,
      industryExclude,
      setIndustryExclude,
      locations,
      setLocations,
      locationChoices,
      revenueLowerBound,
      revenueUpperBound,
      setRevenueLowerBound,
      setRevenueUpperBound,
      employeesLowerBound,
      employeesUpperBound,
      setEmployeesLowerBound,
      setEmployeesUpperBound,
      naturalQuery,
      setNaturalQuery,
      orderedSavedSearchChoices,
      selectedSavedSearch,
      handleSelectSavedSearch,
      initiateDelete,
      handlePinSavedSearch,
      initiateEditSearch,
      pinnedIds,
      rowActions,
      savedSearchCatalog,
      isEditingSavedSearch,
    ]
  );

return {
    panelContext
};
}

export { useFilterPanelContext };
